import { WSNotificationResponse } from "../components/Notifications";

export const selectorActiveNotifications = (
  responses: WSNotificationResponse[]
) => {
  return responses
    .filter(response => {
      return !response.isDismissed;
    })
    .sort((a, b) => {
      return a.priority - b.priority;
    });
};
